import {
  Grid,
  Paper,
  TextField,
  Button,
  Switch,
  FormControlLabel,
  Alert,
  useMediaQuery,
  Box,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import mainLogo from "./img/RatioLogo.svg";
import easyLogo from "./img/EasyGate.svg";
import imageLogoFidalIcona from "./img/logoFidalIcona.jpeg";
import image from "./img/sfondo.jpeg";
import constant from "./Costanti/Constant.js";

export default function Iscrizione() {
  const navigate = useNavigate();
  const isDesktop = useMediaQuery("(min-width:768px)");

  // Aumentiamo la width del Paper a 80% su desktop
  const paperStyle = {
    width: isDesktop ? "80%" : "95%",
    margin: "1rem auto",
  };

  const [isSocieta, setIsSocieta] = useState(false);
  const [alertError, setAlertError] = useState(false);
  const [alertOk, setAlertOk] = useState(false);
  const [msgAlert, setMsgAlert] = useState("");

  const [valueData, setValueData] = useState(dayjs());
  const [nome, setNome] = useState("");
  const [cognome, setCognome] = useState("");
  const [codFisc, setCodFisc] = useState("");
  const [indirizzo, setIndirizzo] = useState("");
  const [comune, setComune] = useState("");
  const [provincia, setProvincia] = useState("");
  const [telefono, setTelefono] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConferma, setPasswordConferma] = useState("");

  const [nomeSocieta, setNomeSocieta] = useState("");
  const [tesseraFidalSocieta, setTesseraFidalSocieta] = useState("");
  const [telefonoSocieta, setTelefonoSocieta] = useState("");

  const handleSubmit = () => {
    if (password !== passwordConferma) {
      setAlertError(true);
      setAlertOk(false);
      setMsgAlert("Attenzione, le password non coincidono");
      return;
    }
    if (password.length < 8) {
      setAlertError(true);
      setAlertOk(false);
      setMsgAlert("Attenzione, la password deve essere di almeno 8 caratteri");
      return;
    } else if (password.length > 20) {
      setAlertError(true);
      setAlertOk(false);
      setMsgAlert(
        "Attenzione, la password deve essere di massimo 20 caratteri"
      );
      return;
    }

    inviorRichiestaIscrizione();
  };

  const inviorRichiestaIscrizione = () => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();
    var hh = today.getHours();
    var min = today.getMinutes();
    var sec = today.getSeconds();

    if (hh < 10) {
      hh = "0" + hh;
    }
    if (min < 10) {
      min = "0" + min;
    }
    if (sec < 10) {
      sec = "0" + sec;
    }

    today = yyyy + mm + dd + hh + min + sec;

    let annoInizio = valueData.year().toString();
    let meseInizio = (valueData.month() + 1).toString();
    let giornoInizio = valueData.date().toString();

    if (meseInizio < 10) {
      meseInizio = `0${meseInizio}`;
    }

    if (giornoInizio < 10) {
      giornoInizio = `0${giornoInizio}`;
    }

    let annoDiNascitaTradotto = `${annoInizio}${meseInizio}${giornoInizio}000000`;
    console.log(annoDiNascitaTradotto);

    const body = JSON.stringify({
      nome: nome,
      cognome: cognome,
      codiceFiscale: codFisc,
      indirizzo: indirizzo,
      comune: comune,
      provincia: provincia,
      dataDiNascita: annoDiNascitaTradotto,
      numeroTelefono: telefono,
      email: email,
      password: password,
      societa: isSocieta,
      nomeSocieta: nomeSocieta,
      tesseraSocieta: tesseraFidalSocieta,
      telefonoSocieta: telefonoSocieta,
      insDate: today,
    });

    console.log(nome);
    console.log(cognome);
    console.log(codFisc);
    console.log(indirizzo);
    console.log(comune);
    console.log(provincia);
    console.log(annoDiNascitaTradotto);
    console.log(telefono);
    console.log(email);
    console.log(password);
    console.log(today);

    fetch(constant.INSERTUTENTE, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
      },
      body: body,
    })
      .then((response) => {
        if (!response.ok) throw setMsgAlert("Errore inserimento utente");
        else return response.json();
      }) //response.json()
      .then((json) => gestioneJson(json));
  };

  const gestioneJson = async (json) => {
    console.log(json);

    const _messaggio = json["messaggio"];
    const _risultato = json["risultato"];

    console.log(_risultato);
    console.log(_messaggio);

    if (_risultato == 500) {
      setAlertError(true);
      setAlertOk(false);
      setMsgAlert(_messaggio);
    } else {
      setAlertError(false);
      setAlertOk(true);
      setMsgAlert(
        "Utente creato correttamente\nVerrai indirizzato automaticamente al login"
      );
      await delay(5000);
      navigate("/login");
    }
  };

  const delay = (ms) => new Promise((res) => setTimeout(res, ms));

  return (
    <div
      style={{
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        width: "100vw",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
        <Paper elevation={10} style={paperStyle}>
          <Grid container>
            {/* Branding */}
            <Grid
              item
              xs={12}
              md={4}
              container
              direction="column"
              justifyContent="space-between"
              sx={{ backgroundColor: "#5E2367", p: 1 }}
            >
              <img src={easyLogo} width={180} alt="EasyGate" />
              <img src={mainLogo} width={220} alt="Ratio" />
              {/* <img src={imageLogoFidalIcona} width={80} alt="Fidal" /> */}
            </Grid>

            {/* Form */}
            <Grid
              item
              xs={12}
              md={8}
              sx={{ p: 4 }}
              container
              direction="column"
              alignItems="center"
            >
              <img src={imageLogoFidalIcona} width={150} alt="logoFidal" />
              <h2 className={"loginAccedi"} style={{ marginTop: 16 }}>
                Registrati
              </h2>
              <Box mb={2}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={isSocieta}
                      onChange={() => setIsSocieta((v) => !v)}
                    />
                  }
                  label={isSocieta ? "SOCIETÀ" : "UTENTE"}
                />
              </Box>

              {alertError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {msgAlert}
                </Alert>
              )}
              {alertOk && (
                <Alert severity="success" sx={{ mb: 2 }}>
                  {msgAlert}
                </Alert>
              )}

              <Grid container spacing={2}>
                {isSocieta ? (
                  <>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Nome Società"
                        fullWidth
                        value={nomeSocieta}
                        onChange={(e) => setNomeSocieta(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Codice FIDAL"
                        fullWidth
                        value={tesseraFidalSocieta}
                        onChange={(e) => setTesseraFidalSocieta(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Telefono Società"
                        fullWidth
                        value={telefonoSocieta}
                        onChange={(e) => setTelefonoSocieta(e.target.value)}
                      />
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Nome"
                        fullWidth
                        value={nome}
                        onChange={(e) => setNome(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Cognome"
                        fullWidth
                        value={cognome}
                        onChange={(e) => setCognome(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Codice Fiscale"
                        fullWidth
                        value={codFisc}
                        onChange={(e) => setCodFisc(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Telefono"
                        fullWidth
                        value={telefono}
                        onChange={(e) => setTelefono(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Indirizzo"
                        fullWidth
                        value={indirizzo}
                        onChange={(e) => setIndirizzo(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Comune"
                        fullWidth
                        value={comune}
                        onChange={(e) => setComune(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <DatePicker
                        label="Data di nascita"
                        views={["year", "month", "day"]}
                        maxDate={dayjs()}
                        value={valueData}
                        onChange={(newVal) => setValueData(newVal)}
                        renderInput={(params) => (
                          <TextField fullWidth {...params} />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Provincia"
                        fullWidth
                        value={provincia}
                        onChange={(e) => setProvincia(e.target.value)}
                      />
                    </Grid>
                  </>
                )}

                {/* Dati di accesso */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Email"
                    fullWidth
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Password"
                    type="password"
                    fullWidth
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Conferma Password"
                    type="password"
                    fullWidth
                    value={passwordConferma}
                    onChange={(e) => setPasswordConferma(e.target.value)}
                  />
                </Grid>
              </Grid>

              {/* Pulsante */}
              <Box mt={3}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={handleSubmit}
                >
                  ISCRIVITI
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </LocalizationProvider>
    </div>
  );
}
